import React from "react";

const BenefitsCard = () => {
	return (
		<div className="new-card benefits-mm-box">
			<header className="new-card__header">
				<h4 className="new-card__title">Por que comprar na MaxMilhas?</h4>
			</header>
			<div className="new-card__content">
				<div className="benefits-mm-box-row">
					<i className="icon icon-check v-center-columns" />
					<p className="value-line v-center-columns">
						{" "}
						Melhor agência de viagens online do site Reclame Aqui
					</p>
				</div>
				<div className="benefits-mm-box-row">
					<i className="icon icon-check v-center-columns" />
					<p className="value-line v-center-columns"> Pague com cartão ou transferência bancária</p>
				</div>
				<div className="benefits-mm-box-row">
					<i className="icon icon-check v-center-columns" />
					<p className="value-line v-center-columns"> Mais de 3 milhões de passagens emitidas</p>
				</div>
				<div className="benefits-mm-box-row border-line">
					<i className="icon icon-check v-center-columns" />
					<p className="value-line v-center-columns"> Atendimento 24h</p>
				</div>
				<div className="certificates">
					<a href="http://www.reclameaqui.com.br/indices/84978/maxmilhas/" target="_blank">
						<img
							className="img-responsive"
							src="https://s3.amazonaws.com/maxmilhas/growth/images/logo_ra_1000.svg"
							alt="Selo Site RA1000"
						/>
					</a>
					<a
						href="https://www.siteblindado.com/consumidor/selo-blindado/?language=pt&amp;hostname=www.maxmilhas.com.br"
						target="_blank"
					>
						<img
							className="img-responsive"
							src="https://s3.amazonaws.com/maxmilhas/growth/images/logo_site_blindado.svg"
							alt="Selo Site Blindado"
						/>
					</a>
				</div>
			</div>
		</div>
	);
};

export default BenefitsCard;
